(function () {
    'use strict';

    var module = angular.module('uwAgenda.charts');

    // main controller for charts
    module.controller('ChartOverviewController',
        ['$scope', '$timeout', '$window', 'SharedAgendaService', 'ChartViewType', 'ChartDataType', 'PaginationService', 'MessageType', 'PatientState', 'chartType', 'agendaLabels', '$rootScope', 'AgendaFilterBroadcast', 'ChartFilterBroadcast', 'HelperService',
            'ChartService', 'DateService', 'DownloadService', ChartOverviewControllerFn]);

    // main controller for charts
    function ChartOverviewControllerFn($scope, $timeout, $window, SharedAgendaService, ChartViewType, ChartDataType, PaginationService, MessageType, PatientState, chartType, agendaLabels, $rootScope, AgendaFilterBroadcast, ChartFilterBroadcast, HelperService,
        ChartService, DateService, DownloadService) {

        var vm = this;
        // chart titles will be updated on load
        var chartTitle = null;
        var chartSubtitle = null;
        // selector for nvd3 svg element
        var nvd3SvgElementSelector = '#nvd3Chart svg';

        var timeoutHandler = null;

        // metronic colors for charts
        var chartColors = [
            '#578EBE', // blue-madison
            '#67809F', // blue-soft
            '#3598DC', // blue
            '#578EBE', // blue-steel
            '#5C9BD1' // blue-sharp
        ];

        // filter visibilty
        vm.isAppointmentChart = false;
        vm.isMessageChart = false;
        vm.isTaskChart = false;

        // overview service for agenda label filter
        vm.overview = null;
        // list of agenda labels
        vm.agendaLabels = [];
        // list of message types
        vm.messageTypes = [];
        // patient states (known/unknown)
        vm.patientStates = [];
        // date range filter
        vm.dateFrom = null;
        vm.dateTo = null;
        // online bookings filter
        vm.onlineBookings = false;
        // currently selected chart view (day/week...)
        vm.selectedView = null;
        // patient filter
        vm.selectedPatient = null;
        // finished tasks filter
        vm.showFinishedTasks = false;

        // chart parameter
        vm.chartOptions = null;
        vm.chartData = null;

        // clear filter
        vm.clear = clear;
        // reload data
        vm.reload = reload;

        // change chart view
        vm.changeView = function (view) {
            vm.selectedView = view;
            reload();
        };

        // download chart as image
        vm.downloadChart = function () {
            var svgNode = d3.select(nvd3SvgElementSelector).node();
            var canvas = createCanvasForExport(svgNode);

            canvas.toBlob(function (blob) {
                fileSaver.saveAs(blob, chartTitle + ".png");
            });
        };

        vm.print = function () {
            // ie can't print svg-content, so we create the png first and print that
            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                var svgNode = d3.select(nvd3SvgElementSelector).node();
                var canvas = createCanvasForExport(svgNode);

                var img = document.getElementById("printImage");
                img.src = canvas.toDataURL("image/png");
                img.width = svgNode.clientWidth;
                img.height = svgNode.clientHeight;

                var btnIe = document.getElementById("printButtonIE");
                btnIe.click();
            }
            else { // for other browsers we use the svg because it has a better quality
                var btn = document.getElementById("printButton");
                btn.click();
            }
        };

        // download chart as pdf
        vm.downloadChartPdf = function () {
            var svg = serializeSvg();
            // Convert SVG string to dataurl
            var url = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
            DownloadService.exportChart(SharedAgendaService.currentUser().id, url);
        };

        $scope.$on('$destroy', function () {
            if (timeoutHandler) {
                $timeout.cancel(timeoutHandler);
                timeoutHandler = null;
            }

            angular.element($window).off('resize');
        });

        activate();

        // activation work
        function activate() {
            // allow shared agenda-switch
            SharedAgendaService.allow();
            // initialise overview service
            vm.overview = new PaginationService([]);

            // set title info and filter visibility flags according to selected chart type
            var agendaOwner = SharedAgendaService.currentUser().caption;
            switch (chartType) {
                case ChartDataType.Appointment:
                    vm.isAppointmentChart = true;
                    vm.isMessageChart = false;
                    vm.isTaskChart = false;
                    break;
                case ChartDataType.DayTask:
                    vm.isAppointmentChart = false;
                    vm.isMessageChart = false;
                    vm.isTaskChart = true;
                    break;
                case ChartDataType.Message:
                    vm.isAppointmentChart = false;
                    vm.isMessageChart = true;
                    vm.isTaskChart = false;
                    break;
            }

            // set filter data
            vm.agendaLabels = [];
            for (var i = 0; i < agendaLabels.length; i++) {
                vm.agendaLabels.push(agendaLabels[i]);
            }

            vm.messageTypes = [];
            vm.messageTypes.push(MessageType.IncomingSMS);
            vm.messageTypes.push(MessageType.OutgoingSMSByUser);
            vm.messageTypes.push(MessageType.OutgoingSMSByServer);
            vm.messageTypes.push(MessageType.IncomingCall);
            vm.messageTypes.push(MessageType.OutgoingCallToClient);
            vm.messageTypes.push(MessageType.OutgoingCallToPatientInvoiced);
            vm.messageTypes.push(MessageType.OutgoingCallForIVR);
            vm.messageTypes.push(MessageType.IVRCall);
            vm.messageTypes.push(MessageType.AICall);
            vm.messageTypes.push(MessageType.OperatorAndAICall);

            vm.patientStates = [];
            vm.patientStates.push(PatientState.Known);
            vm.patientStates.push(PatientState.Unknown);

            // set default chart view
            vm.selectedView = ChartViewType.Day.value;

            // initialize chart options
            setChartOptions();

            // set filter to default values
            clear();

            //chart titles are positioned manually, so we have to reposition them on window resize
            angular.element($window).on('resize', function () {
                timeoutHandler = $timeout(function () {
                    updateChartTitles();
                });
            });

            // load data
            reload();
        } // activate

        //clear filter
        function clear() {
            vm.selectedPatient = null;
            vm.onlineBookings = false;
            vm.showFinishedTasks = false;

            for (var i = 0; i < vm.agendaLabels.length; i++) {
                vm.agendaLabels[i].vmSelected = false;
            }

            for (var j = 0; j < vm.messageTypes.length; j++) {
                vm.messageTypes[j].vmSelected = false;
            }

            for (var k = 0; k < vm.patientStates.length; k++) {
                vm.patientStates[k].vmSelected = false;
            }

            if (DateService.data.info.firstDayOfWeek) {
                vm.dateFrom = DateService.data.info.firstDayOfWeek;
                vm.dateTo = DateService.data.info.lastDayOfWeek;
            } else {
                vm.dateFrom = new Date();
                vm.dateTo = new Date();
            }

            // inform listener
            $rootScope.$broadcast(AgendaFilterBroadcast.AgendaLabelRefresh);
            $rootScope.$broadcast(AgendaFilterBroadcast.AgendaLabelClear);
            $rootScope.$broadcast(ChartFilterBroadcast.MessageTypeRefresh);
            $rootScope.$broadcast(ChartFilterBroadcast.PatientStateRefresh);
        }

        // reload data
        function reload() {
            HelperService.block("#filterView");

            // call api according to selected chart type
            switch (chartType) {
                // appointments
                case ChartDataType.Appointment:
                    loadAppointments();
                    break;

                    // daytasks
                case ChartDataType.DayTask:
                    ChartService.getDayTasks(SharedAgendaService.data.currentAgenda.id, vm.dateFrom, vm.dateTo, vm.showFinishedTasks, vm.selectedView).then(function (result) {
                        setData(result);
                    });
                    break;

                    // messages
                case ChartDataType.Message:
                    // get selected messageTypes
                    var selectedMessageTypes = [];
                    for (var k = 0; k < vm.messageTypes.length; k++) {
                        if (vm.messageTypes[k].vmSelected === true) {
                            selectedMessageTypes.push(vm.messageTypes[k].value);
                        }
                    }

                    // call api
                    ChartService.getMessages(SharedAgendaService.data.currentAgenda.id, vm.dateFrom, vm.dateTo, vm.selectedView, selectedMessageTypes).then(function (result) {
                        setData(result);
                    });
                    break;
            }
        } // reload

        // load appointments with filters
        function loadAppointments() {

            // get selected agendalabel ids
            var selectedAgendaLabelIds = [];
            for (var j = 0; j < vm.agendaLabels.length; j++) {
                if (vm.agendaLabels[j].vmSelected === true) {
                    selectedAgendaLabelIds.push(vm.agendaLabels[j].id);
                }
            }

            // get selected patientStates
            var selectedPatientStates = [];
            for (var i = 0; i < vm.patientStates.length; i++) {
                if (vm.patientStates[i].vmSelected === true) {
                    selectedPatientStates.push(vm.patientStates[i].value);
                }
            }
            // if none of both states are selected, select all appointments -> set flag to null
            // if only one state is selected, set flag according to selected state
            var confirmedPatients = null;
            if (selectedPatientStates.length === 1) {
                confirmedPatients = selectedPatientStates[0] === PatientState.Known.value;
            }

            var patientId = vm.selectedPatient && vm.selectedPatient.id > 0 ? vm.selectedPatient.id : null;

            // call api
            ChartService.getAppointments(SharedAgendaService.data.currentAgenda.id, vm.dateFrom, vm.dateTo, vm.onlineBookings, vm.selectedView, selectedAgendaLabelIds,
                patientId, confirmedPatients).then(function (result) {
                    setData(result);
                });
        }

        // set chart data
        function setData(chartDto) {
            HelperService.unblock("#filterView");

            // set translated axis labels
            vm.chartOptions.chart.xAxis.axisLabel = chartDto.timeIntervalTitle;
            vm.chartOptions.chart.yAxis.axisLabel = chartDto.dataTypeTitle;

            // clear existing data
            vm.chartData = [];
            chartTitle = chartDto.chartTitle;
            chartSubtitle = chartDto.chartSubtitle;

            for (var i = 0; i < chartDto.chartBars.length; i++) {
                // datalist is received as object, so we convert it to an array
                var values = convertDataObjectToArray(chartDto.chartBars[i].dataList);

                if (values.length > 0) {
                    vm.chartData.push({
                        'key': chartDto.chartBars[i].dataTitle, // chart-line title
                        'values': values // chart-line values for x- & y-axis
                    });
                }
            }

            //  if no data is found, the svg-render method is not called and the additional chart-titles have to be updated/removed manually
            if (chartDto.chartBars.length === 0) {
                var titleNode = d3.select('.chartTitle').node();
                if (titleNode !== null && titleNode !== undefined) {
                    titleNode.remove();
                }
                var subtitleNode = d3.select('.chartSubtitle').node();
                if (subtitleNode !== null && subtitleNode !== undefined) {
                    subtitleNode.remove();
                }
            }
        }

        // updates chart titles (directly append in svg after chart has been loaded to include them in exports too)
        function updateChartTitles() {
            var svg = d3.select(nvd3SvgElementSelector);
            var svgNode = svg.node();

            if (svgNode !== null) {
                var xPos = svgNode.clientWidth / 2;
                var maxTextWidth = svgNode.clientWidth - (2 * vm.chartOptions.chart.margin.left);

                //add chart title
                var titleNode = d3.select(nvd3SvgElementSelector + ' .chartTitle').node();
                if (titleNode !== null) {
                    titleNode.remove();
                }

                var titleTmp = svg.append("text")
                    .attr("x", xPos)
                    .attr("y", 30)
                    .attr("text-anchor", "middle")
                    .attr("font-weight", "800")
                    .attr("font-size", "18")
                    .attr("font-family", "Open Sans, sans-serif")
                    .attr('class', 'chartTitle');

                var titleSpan = titleTmp.append('tspan')
                    .text(chartTitle);

                wrapSvgText(titleSpan, maxTextWidth);
                titleNode = titleTmp.node();

                // add subtitle
                var subtitleNode = d3.select(nvd3SvgElementSelector + ' .chartSubtitle').node();
                if (subtitleNode !== null) {
                    subtitleNode.remove();
                }

                var subtitleTmp = svg.append("text")
                    .attr("x", xPos)
                    .attr("y", 50)
                    .attr("font-family", "Open Sans, sans-serif")
                    .attr("text-anchor", "middle")
                    .attr("font-weight", "800")
                    .attr('class', 'chartSubtitle');

                var subtitleSpan = subtitleTmp.append('tspan')
                    .text(chartSubtitle);

                wrapSvgText(subtitleSpan, maxTextWidth);
                subtitleNode = subtitleTmp.node();
            }
        }

        function wrapSvgText(textElement, maxWidth) {
            var textLength = textElement.node().getComputedTextLength(),
                text = textElement.text();

            while (textLength > maxWidth && text.length > 0) {
                text = text.slice(0, -1);
                textElement.text(text + '...');
                textLength = textElement.node().getComputedTextLength();
            }
        }

        function addValueLabels() {
            d3.selectAll('.nv-multibar .nv-group').each(function (group) {
                var g = d3.select(this);

                // Remove previous labels if there is any
                g.selectAll('text').remove();
                g.selectAll('.nv-bar').each(function (bar) {
                    var b = d3.select(this);
                    var barWidth = b.attr('width');
                    var barHeight = b.attr('height');

                    g.append('text')
                        // Transforms shift the origin point then the x and y of the bar
                        // is altered by this transform. In order to align the labels
                        // we need to apply this transform to those.
                        .attr('transform', b.attr('transform'))
                        .text(function () {
                            return bar.count;
                        })
                        .attr('y', function () {
                            // put label under top end of bar or if value is 0 put it above the bar
                            var offset = 0;
                            if (bar.count > 0)
                                offset = 15;
                            else
                                offset = -5;
                            return parseFloat(b.attr('y')) + offset;
                        })
                        .attr('x', function () {
                            // Center label horizontally
                            var width = this.getBBox().width;
                            return parseFloat(b.attr('x')) + (parseFloat(barWidth) / 2) - (width / 2);
                        })
                        .attr('fill', 'black')
                        .attr('stroke-opacity', '0');
                });
            });
        }

        // format date values on x-axis
        function formatXAxis(d) {
            switch (vm.selectedView) {
                case ChartViewType.Day.value:
                    var utc = new Date(0);
                    utc.setUTCMilliseconds(d);
                    return d3.time.format('%d/%m/%Y')(utc);

                case ChartViewType.Week.value:
                    var utcw = new Date(0);
                    utcw.setUTCMilliseconds(d);
                    return d3.time.format('%W')(utcw);

                case ChartViewType.Year.value:
                    return d3.format("d")(d);

                default:
                    return d;
            }
        }

        // convert a list-object to an array
        function convertDataObjectToArray(dataObject) {
            var dataArray = [];

            for (var date in dataObject) {
                if (dataObject.hasOwnProperty(date)) {
                    var count = dataObject[date];
                    dataArray.push({ date: date, count: count });
                } //if
            } // for

            return dataArray;
        }

        // get styles of the svg and convert them to a string
        function getCSSStyles() {
            // Extract CSS Rules
            var extractedCSSText = "";
            for (var i = 0; i < document.styleSheets.length; i++) {
                var s = document.styleSheets[i];

                var cssRules = null;
                try {
                    cssRules = s.cssRules;
                } catch (ex) {
                    continue;
                }

                if (cssRules) {
                    var css = '';
                    for (var r = 0; r < cssRules.length; r++) {
                        try {
                            css = cssRules[r].cssText;
                        }
                        catch (ex) {
                            continue;
                        }

                        // remove font-src styles, since the url-paths don't exist (js) and cause errors
                        if (css.indexOf('src:') >= 0) {
                            css = css.replace(/@font-face[^}]*}/ig, '');
                        }
                        extractedCSSText += ' ' + css;
                    }
                }
            }

            return extractedCSSText;
        }

        // gets the dataUrl from the chart svg
        function serializeSvg() {
            //get svg
            var svgNode = d3.select(nvd3SvgElementSelector).node();

            // remove defs from previous serializations
            for (var i = 0; i < svgNode.childNodes.length; i++) {
                if (svgNode.childNodes[i].localName === "defs") {
                    svgNode.removeChild(svgNode.childNodes[i]);
                    break;
                }
            }

            // add external css styles to svg
            // var styleElement = document.createElement("style");
            // styleElement.setAttribute("type", "text/css");
            // styleElement.innerHTML = getCSSStyles();

            var defs = document.createElement('defs');
            // defs.appendChild(styleElement);
            svgNode.insertBefore(defs, svgNode.firstChild);

            // serialize svg to xml string and create data url
            var serializer = new XMLSerializer();
            var svgString = serializer.serializeToString(svgNode);
            return svgString;
        }

        function createCanvasForExport(svgNode) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext('2d');
            canvas.width = svgNode.clientWidth;
            canvas.height = svgNode.clientHeight;

            var svgString = serializeSvg();

            var v = canvg.Canvg.fromString(ctx, svgString);
            v.render();
            return canvas;
        }

        // set chart options
        function setChartOptions() {
            vm.chartOptions = {
                chart: {
                    height: 700,
                    type: 'multiBarChart', //chart type
                    margin: { // margins between border and chart itself
                        top: 130,
                        right: 50,
                        bottom: 60,
                        left: 50
                    },
                    duration: 100,
                    stacked: true, // show multiple lines stacked
                    legend: {
                        margin: { // margin between chart and legend
                            top: 40,
                            bottom: 10
                        }
                    },
                    showControls: true, // show/hide controls for switching chart lines display
                    controls: { // margin between chart and controls
                        margin: {
                            top: 40,
                            bottom: 10
                        }
                    },
                    color: function (d, i) {
                        var colorIndex = i % (chartColors.length - 1);
                        // if i is a multiple of colors count, mod returns 0 too, but should be last index of color array
                        if (colorIndex === 0 && i !== 0) {
                            colorIndex = chartColors.length - 1;
                        }

                        return chartColors[colorIndex];
                    },
                    x: function (d) {
                        return d.date;
                    }, // x-axis property of the given chartdata
                    y: function (d) {
                        return d.count;
                    }, // y-axis property of the given chartdata
                    valueFormat: function (d) {
                        return d3.format("d")(d); // format for y-axis values
                    },
                    xAxis: {
                        axisLabel: '', // description of x-axis, will be updated on reload
                        rotateLabels: 20,
                        showMaxMin: false,
                        tickFormat: function (d) {
                            return formatXAxis(d); // format for x-axis values (integer or date)
                        }
                    },
                    yAxis: {
                        axisLabel: '', // description of y-axis, will be updated on reload
                        axisLabelDistance: -20, // distance between description and value-interval line
                        showMaxMin: false,
                        tickFormat: function (d) {
                            return d3.format("d")(d); // format for y-axis values (always integer)
                        }
                    },
                    dispatch: {
                        renderEnd: function (e) {
                            updateChartTitles(); // append chartTitle directly in svg after chart has been loaded to include them in exports too
                            addValueLabels(); // add the value-labels to the bars
                        }
                    }
                }
            };
        } // setChartOptions

    }
})();